import api from './api'
import { API_ENDPOINTS } from '@/utils/constants'

export const organizationService = {
  async getOrganizations() {
    return api.get(API_ENDPOINTS.ORGANIZATIONS.LIST)
  },

  async createOrganization(name) {
    return api.post(API_ENDPOINTS.ORGANIZATIONS.CREATE, { name })
  },

  async selectOrganization(orgId) {
    return api.post(API_ENDPOINTS.ORGANIZATIONS.SELECT(orgId))
  },

  async getUsage(orgId) {
    return api.get(API_ENDPOINTS.ORGANIZATIONS.USAGE(orgId))
  }
}
